import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AppSettings } from './config';
import * as jwt_decode from "jwt-decode";

@Injectable()
export class GeneralService {
    private main: string = "main";
    public AppSettings = new AppSettings;

    private PaginationNoOrder = new BehaviorSubject<number>(0);
    GetPaginationNoOrder = this.PaginationNoOrder.asObservable();
    SetPaginationOrder(item) {
        this.PaginationNoOrder.next(item);
    }

    private PaginationNoProduct = new BehaviorSubject<number>(0);
    GetPaginationNoProduct = this.PaginationNoProduct.asObservable();
    SetPaginationProduct(item) {
        this.PaginationNoProduct.next(item);
    }

    private PosOrder = new BehaviorSubject<object>([]);
    GetPosOrder = this.PosOrder.asObservable();
    SetPosOrder(item) {
        this.PosOrder.next(item); 
        localStorage.setItem('OrdersPOS', JSON.stringify(item));
    }

    // private UserData = new BehaviorSubject<any>([]);
    // GetUserData = this.UserData.asObservable();

    useraccess: boolean = false;
    userrol: number = 0;
    menu = {};
    menuitem = [];

    constructor(private http: HttpClient) { }    
    userSess (){
        let myUser: any = localStorage.getItem('currentUser');
        myUser = JSON.parse(myUser);
        let jwt = jwt_decode(myUser.token);
        return jwt;
    }
    ChkMenu(){
        if ( localStorage.getItem('OrdersPOS') ) {
            let help = localStorage.getItem('OrdersPOS');
            if ( help.length > 0 ) {
                this.PosOrder.next( JSON.parse(help) );
            }
        }

        let myUser: any = localStorage.getItem('currentUser');
        myUser = JSON.parse(myUser);
        try{
            this.menuitem = [];
            let jwt = jwt_decode(myUser.token);
            this.menu = {
                state: 'dashboard',
                name: 'Inicio',
                type: 'link',
                icon: 'home',
            }
            this.menuitem.push(this.menu);
            if (jwt.info.m1 === '1'){
                this.menu ={
                    state: 'cms',
                    name: 'CMS',
                    type: 'sub',
                    icon: 'text_format',
                    children: [
                      {state: 'index', name: 'Paginas'},
                      {state: 'menu', name: 'Menu'},
				      {state: 'menu2', name: 'Menu2'},
					  {state: 'inicio', name: 'Home'},					  
                      {state: 'banners', name: 'Banners Principal'},
                      //{state: 'bannersa', name: 'Banners'},
                      //{state: 'news', name: 'Novedades'},
                      {state: 'benefic', name: 'Beneficios'},
                      //{state: 'clients', name: 'Clientes'},
                      {state: 'ratingprods', name: 'Comentarios'},
                      {state: 'navprods', name: 'Home Slider Products'},
                      {state: 'landing', name: 'Landing'},
                      {state: 'theme', name: 'Theme Config'}


                    ]
                };
                this.menuitem.push(this.menu);
            }
            if (jwt.info.m2 === '1'){
                this.menu = {
                    state: 'users',
                    name: 'Usuarios',
                    type: 'link',
                    icon: 'account_circle'
                };
                this.menuitem.push(this.menu);
            }
            if (jwt.info.m3 === '1'){
                this.menu = {
                    state: 'clients',
                    name: 'Clientes',
                    type: 'sub',
                    icon: 'people',
                    children: [
                      {state: 'index', name: 'Clientes'},
                    
                    ]
                };
                this.menuitem.push(this.menu);
            }
            if (jwt.info.m4 === '1'){
                this.menu = {
                    state: 'providers',
                    name: 'Proveedores',
                    type: 'sub',
                    icon: 'people',
                    children: [
                      {state: 'index', name: 'Proveedores'},
                      {state: 'whouses', name: 'Bodegas'},
                    ]
                };
                this.menuitem.push(this.menu);
            }
             
            if (jwt.info.m5 === '1' || jwt.info.m6 === '1'){
                this.menu = {
                    state: 'products',
                    name: 'Productos',
                    type: 'sub',
                    icon: 'apps',
                    children: [
                      {state: 'index', name: 'Productos'},
                      {state: 'update', name: 'Actualización'},
                      {state: 'inventories', name: 'Inventarios'},
                      {state: 'item', name: 'Items'},
                      {state: 'cupons', name: 'Cupones'},
                      {state: 'categories', name: 'Categorias'},
                      {state: 'properties', name: 'Atributos'},
                      {state: 'specifications', name: 'Especificaciónes'},
                      {state: 'caract', name: 'Caracteristicas'},
                      {state: 'sku', name: 'Ubicacion Skus'},
                    ]
                };
                this.menuitem.push(this.menu);
            }            
            if (jwt.info.m7 === '1'){
                this.menu = {
                    state: 'sales',
                    name: 'Ventas',
                    type: 'sub',
                    icon: 'attach_money',
                    children: [
                      {state: 'index', name: 'Pedidos'},

                     // {state: 'factura', name: 'Facturacion'},
                      {state: 'error', name: 'Errores Inventario'},
                      {state: 'delivery', name: 'Despachos'},
                      {state: 'pdd', name: 'PDD'},
                      {state: 'devolucion', name: 'Devoluciones'},
                      {state: 'cambio', name: 'Cambios'},
                      {state: 'transp', name: 'Transportadora'},
                    ]
                };
                this.menuitem.push(this.menu);
                this.menu = {
                    state: 'logistics',
                    name: 'Logistica',
                    type: 'sub',
                    icon: 'apps',
                    children: [
                        {state: 'states', name: 'Estados / Departamentos'},
                        {state: 'cities', name: 'Ciudades'},
                        {state: 'price', name: 'Tabla de precios'}
                    ]
                };
                this.menuitem.push(this.menu);
            }
            
            if (jwt.info.m11 === '1'){
                this.menu = {
                    state: 'pos',
                    name: 'POS',
                    type: 'link',
                    icon: 'attach_money',
                };
                this.menuitem.push(this.menu);
            }
            if (jwt.info.m14 === '1'){
                this.menu = {
                    state: 'trans',
                    name: 'Transportadora - cliente',
                    type: 'link',
                    icon: 'attach_money',
                };
                this.menuitem.push(this.menu);
            }
            if (jwt.info.m14 === '1'){
                this.menu = {
                    state: 'transC',
                    name: 'Cliente - Transportadora',
                    type: 'link',
                    icon: 'attach_money',
                };
                this.menuitem.push(this.menu);
            }
            /*if (jwt.info.m14 === '1'){
                this.menu = {
                    state: 'transconta',
                    name: 'Transportadora contabilidad',
                    type: 'link',
                    icon: 'attach_money',
                };
                this.menuitem.push(this.menu);
            }*/
            if (jwt.info.m8 === '1'){
                this.menu = {
                    state: 'marketing',
                    name: 'Marketing',
                    type: 'link',
                    icon: 'assignment',
                };
                this.menuitem.push(this.menu);
            }
            if (jwt.info.m9 === '1'){
                this.menu = {
                    state: 'reports', 
                    name: 'Reportes',
                    type: 'sub',
                    icon: 'assignment',
                    children: [
                      {state: 'inventary', name: 'Inventario'},
                      {state: 'pagos', name: 'Pagos'},
                      {state: 'prodsale', name: 'Historial Venta de producto'},
                      {state: 'salesgd', name: 'Venta Dia'},
                      {state: 'salesg', name: 'Venta General'},
                      {state: 'salesc', name: 'Venta X Ciudad'},
                      {state: 'salesd', name: 'Venta X Departamento'},
                      {state: 'salesmp', name: 'Venta X Medio Pago'},
                      {state: 'salesoper', name: 'Venta X Operador'},
                      {state: 'salesprod', name: 'Venta X Producto'},
                      {state: 'salescat', name: 'Venta X Categoría'},
                      {state: 'salespm', name: 'Ventas promo'},
                      {state: 'userspb', name: 'Usuarios Publicidad'},
                      {state: 'negativos', name: 'Negativos'},
                      {state: 'trasportw', name: 'Transportadora'},
                     

                    ]
                };
                this.menuitem.push(this.menu);
            }
            if (jwt.info.m10 === '1'){
                this.menu = {
                    state: 'config',
                    name: 'Config',
                    type: 'link',
                    icon: 'build',
                };
                this.menuitem.push(this.menu);
            }
            this.menu = {
                state: 'auth',
                name: 'Salir',
                type: 'link',
                icon: 'exit_to_app'
            };
            this.menuitem.push(this.menu);
        }
        catch(Error){
            console.log(Error);
        }
    }
    chkAccess(modulo){
        let myUser: any = localStorage.getItem('currentUser');
        myUser = JSON.parse(myUser);
        try{
            let jwt = jwt_decode(myUser.token);
            if (jwt.info["m"+modulo]){
                if (jwt.info["m"+modulo] === '1'){
                    this.useraccess = true;
                    this.userrol = jwt.info.rol;
                } else {
                    this.useraccess = false;
                }
            } else {
                this.useraccess = false;
            }
        }
        catch(Error){
            this.useraccess = false;
        }
    }

    /* GET index */
    getData(controller,page,id,filter): Observable<any> {
        const body = new HttpParams()
            .set('page', JSON.stringify(page))
            .set('id', id)
            .set('filter', JSON.stringify(filter));
            

        return this.http.post(this.AppSettings.URL + controller + '/index',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getData', []))
        );
    }  
    
    getData2(controller,page,id,filter): Observable<any> {
        const body = new HttpParams()
            .set('page', JSON.stringify(page))
            .set('id', id)
            .set('filter', JSON.stringify(filter));

        return this.http.post(this.AppSettings.URL + controller + '/index2',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getData2', []))
        );
    }
   /* GetResul(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('ac', '3');
        return this.http.post(this.AppSettings.URL + 'orders/GetResul',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('GetResul', []))
        );
    }

*/



    AddInventary(controller, id, coment): Observable<any> {
        const body = new HttpParams()
        .set('id', id)
        .set('coment', coment);

        return this.http.post(this.AppSettings.URL + controller +'/AddInventary',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('AddInventary', []))
        );
    }
    /*
    Getpeden(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('ac', '2');
        return this.http.post(this.AppSettings.URL + 'orders/GetResul',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded'),
            },
        ).pipe(
            catchError(this.handleError('GetResul', []))
        );
    }
    */
    GetCsv2(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/planokaren',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded'),
                responseType: 'text'
            },
        ).pipe(
            catchError(this.handleError('planokaren', []))
        );
    }
    /* GET detail */  
    getRow(controller, id): Observable<any> {
        const body = new HttpParams()
            .set('id', JSON.stringify(id));

        return this.http.post(this.AppSettings.URL + controller + '/data',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getRow', []))
        );
    }
    /* POST form */
    saveForm2(controller, id, fvalue): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('fvalue', JSON.stringify(fvalue));
            
            
        return this.http.post(this.AppSettings.URL + controller + '/savedoc',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('saveForm2', []))
        );
    }
    saveFormMercadolibre(controller, id, fvalue): Observable<any> {
        const body = new HttpParams()
            .set('id', JSON.stringify(id))
            .set('fvalue', JSON.stringify(fvalue));
            
            
        return this.http.post(this.AppSettings.URL + controller + '/saveMercadolibre',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('saveFormMercadolibre', []))
        );
    }
    facturacion(controller, caja): Observable<any> {
        const body = new HttpParams()
            .set('fvalue', JSON.stringify(caja))
            // console.log();
        return this.http.post(this.AppSettings.URL + controller + '/factura',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('facturacion', []))
        );
    }
    saveEmail(controller, id): Observable<any> {
        const body = new HttpParams()
            .set('id',id)
        return this.http.post(this.AppSettings.URL + controller + '/sendEmailContabilidad',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('saveEmail', []))
        );
    }
    saveComen(controller, id, comment,state): Observable<any> {
        const body = new HttpParams()
            .set('id',id)
            .set('state', JSON.stringify(state))
            .set('comment', JSON.stringify(comment));

        return this.http.post(this.AppSettings.URL + controller + '/savecoment',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('saveComen', []))
        );
    }
    saveForm(controller,id, fvalue): Observable<any> {        
        const body = new HttpParams()
            .set('id', JSON.stringify(id))
            .set('fvalue', JSON.stringify(fvalue));

        return this.http.post(this.AppSettings.URL + controller + '/save',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('saveForm', []))
        );
    }
    saveDirec(controller,id, ida, toito): Observable<any> {
        const body = new HttpParams()
            .set('id', JSON.stringify(id))        
            .set('ida', JSON.stringify(ida))
            .set('fvalue', JSON.stringify(toito))
            // console.log();
        return this.http.post(this.AppSettings.URL + controller + '/Direccion',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('facturacion', []))
        );
    }
    unir( id, orden): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('orden', orden);

        return this.http.post(this.AppSettings.URL + 'orders/unirP',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('saveComen', []))
        );
    }
    delDataCC(controller, id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + controller + '/cancelar',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('delDataCC', []))
        );
    }
    /* DELETE row */
    delData(controller, id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + controller + '/delete',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('delData', []))
        );
    }
    delData22(controller, id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + controller + '/delete22',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('delData22', []))
        );
    }
    /* DELETE row */
    checksubmenu(controller,id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + controller + '/getcategorycheck',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('categorycheck', []))
        );
    }





    /* GET detail */  
    CheckInventary(prod, cant): Observable<any> {
        const body = new HttpParams()
            .set('prod',prod)
            .set('cant', cant);

        return this.http.post(this.AppSettings.URL + 'main/checkInventary',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('CheckInventary', []))
        );
    }
    despacho(controller, id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + controller + '/despacho',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('despacho', []))
        );
    }

    /*********************************************************************/
    //FUNCIONES GLOBALES
    /*********************************************************************/

    /* Función que trae los departamentos del api */    
    getStates(id,id2): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('id2', id2);

        return this.http.post(this.AppSettings.URL + this.main + '/getStates',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getStates', []))
        );
    }
    /* Función que trae las ciudades del api */    
    getCitys(id,id2): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('id2', id2);

        return this.http.post(this.AppSettings.URL + this.main + '/getCitys',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getCitys', []))
        );
    }
    /* Función que trae bodegas del api */    
    getWhouses(id,id2): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('id2', id2);

        return this.http.post(this.AppSettings.URL + this.main + '/getWhouses',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getWhouses', []))
        );
    }
    /* Función que trae productos del api */    
    getProducts(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + this.main + '/getProducts',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getProducts', []))
        );
    }
    /* Función que trae clientes del api */    
    getClients(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + this.main + '/getClients',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getClients', []))
        );
    }
    /* Función que trae clientes del api */    
    getStateSales(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + this.main + '/getStateSales',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getStateSales', []))
        );
    }
    /* Función que trae clientes del api */    
    getPayment(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + this.main + '/getPayment',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getPayment', []))
        );
    }   
    getDepart(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + this.main + '/getDepart',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getDepart', []))
        );
    }
    getCity(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + this.main + '/getCity',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getCity', []))
        );
    } 
   /* Función que trae clientes del api */    
   getAddress(id,id2): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('id2', id2);

        return this.http.post(this.AppSettings.URL + this.main + '/getAddress',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getAddress', []))
        );
    }
    /* Función que trae clientes del api */    
    getInventory(id,id2,id3): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('id2', id2)
            .set('id3', id3);

        return this.http.post(this.AppSettings.URL + this.main + '/getInventory',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getInventory', []))
        );
    }
    precio(id,num): Observable<any>{
        const body = new HttpParams()
        .set('id', id)
        .set('num', num);
        return this.http.post(this.AppSettings.URL + this.main + '/newprecio',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('home', []))
        );
    }
    direccion(id,num): Observable<any>{
        const body = new HttpParams()
        .set('id', id)
        .set('num', num);
        return this.http.post(this.AppSettings.URL + this.main + '/direccion',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('home', []))
        );
    }
    /* Función que trae clientes del api */    
    GetInvoiceNext(): Observable<any> {
        const body = new HttpParams()
            .set('id', '');

        return this.http.post(this.AppSettings.URL + 'orders' + '/GetInvoiceNext',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('GetInvoiceNext', []))
        );
    }
    /* Función que trae clientes del api */    
    getOrders(id,id2,id3): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('id2', id2)
            .set('id3', id3);

        return this.http.post(this.AppSettings.URL + this.main + '/getOrders',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getOrders', []))
        );
    }
    GetWhatsApp(id){
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/WhatsApp',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('getwhatsapp', []))
        );
    }
    
    Getcomentarios(id){
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/Coments',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('getcoments', []))
        );
    }
    GetcomentNovedad(id){
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/ComentNovedad',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('GetcomentNovedad', []))
        );
    }
    GetImg(id){
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'main/img',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('getcoments', []))
        );
    }
    GetResul(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('ac', '3');
        return this.http.post(this.AppSettings.URL + 'orders/GetResul',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('GetResul', []))
        );
    }
    Getpeden(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id)
            .set('ac', '2');
        return this.http.post(this.AppSettings.URL + 'orders/GetResul',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded'),
            },
        ).pipe(
            catchError(this.handleError('GetResul', []))
        );
    }
    /* Función que trae clientes del api */    
    GetPdf(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/GetPdf',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded'),
                responseType: 'text'
            },
        ).pipe(
            catchError(this.handleError('GetPdf', []))
        );
    }   
    GetPdf2(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/GetPdf2',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded'),
                responseType: 'text'
            },
        ).pipe(
            catchError(this.handleError('GetPdf2', []))
        );
    } 
    getHome(): Observable<any> {
        const body = new HttpParams()
            .set('id', '1');

        return this.http.post(this.AppSettings.URL + 'main/home',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('home', []))
        );
    }
    getAsesors(): Observable<any>{
        const body = new HttpParams()
        return this.http.post(this.AppSettings.URL + 'main/asesor',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('home', []))
        );
    }
   
    getAsesorstime(): Observable<any>{
        const body = new HttpParams()
        return this.http.post(this.AppSettings.URL + 'main/asesortime',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('home', []))
        );
    }
    getAsesorsmsg(): Observable<any>{
        const body = new HttpParams()
        return this.http.post(this.AppSettings.URL + 'main/msgSinleer',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('home', []))
        );
    }
    getOrdenP(): Observable<any>{
        const body = new HttpParams()
        return this.http.post(this.AppSettings.URL + 'main/ordenP',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('home', []))
        );
    }
    /* Función que trae clientes del api */    
    GetCsv(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/getCsv',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded'),
                responseType: 'text'
            },
        ).pipe(
            catchError(this.handleError('getCsv', []))
        );
    }  

    /* Funcion que trae los comentarios de la orden*/

    /*Getcomentarios(id){
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/Coments',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('getcoments', []))
        );
    }
*/


    /* Función que trae clientes del api */    
    SendEmail(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + 'orders/SendEmail',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('SendEmail', []))
        );
    }
    getMenus(): Observable<any> {
        const body = new HttpParams()
            .set('id', '1');
        return this.http.post(this.AppSettings.URL + 'main/getMenus',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            },
        ).pipe(
            catchError(this.handleError('getMenus', []))
        );
    }
    /* Función que trae clientes del api */    
    GetCataPdf(tipo,ids): Observable<any> {
        const body = new HttpParams()
            .set('tipo', tipo)
            .set('ids', ids);

        return this.http.post(this.AppSettings.URL + 'main/GetCataPdf',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded'),
                responseType: 'text'
            },
        ).pipe(
            catchError(this.handleError('GetCataPdf', []))
        );
    }
    /* Función que trae clientes del api */    
    getProdsByCat(id): Observable<any> {
        const body = new HttpParams()
            .set('id', id);

        return this.http.post(this.AppSettings.URL + this.main + '/getProdsByCat',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).pipe(
            catchError(this.handleError('getProdsByCat', []))
        );
    }
    /**
    * Handle Http operation that failed.
    * Let the app continue.
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
    private handleError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

        // TODO: send the error to remote logging infrastructure
        console.error(error); // log to console instead

        // TODO: better job of transforming error for user consumption
        this.log(`${operation} failed: ${error.message}`);

        // Let the app keep running by returning an empty result.
        return of(result as T);
        };
    }
    private log(message: string) {
        console.log(message);
    }
}


// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/helpers/general.service.ts